/**
 * Coral hub (coral-gables / coral-ceramic / coral-resin):
 * Step 1 venue grid from Shopify type collection (city products).
 * Page shell + skeleton paint from Liquid (sync). Catalog + events-batch
 * run in the background; venue list paints once when enrich finishes.
 * Scroll reveals +12 from the sorted buffer.
 */
(function (global) {
  'use strict';
  function __amcT(s){var m=window.__AMC_I18N__;return (m&&m[s])||s;}


  if (global.WorkshopBookingCoralHub) return;

  var CORAL_SUFFIXES = {
    'coral-gables': 'mosaic-workshops',
    'coral-ceramic': 'ceramic-workshops',
    'coral-resin': 'resin-workshops',
  };

  var INITIAL_TARGET = 20;
  var PAGE_SIZE = 12;

  /**
   * Broader catalog: auto/waitlist city products often land in `workshops` before
   * the typed collection (mosaic-workshops / …). Merge both so hub stays complete.
   */
  var ALL_WORKSHOPS_COLLECTION = 'workshops';

  /** Canada permanent store — pin to top of hub list (inventory venue_type=store). Barrie is popup. */
  var STORE_CITIES = ['Vaughan'];

  function templateSuffix() {
    var main = document.getElementById('MainContent');
    if (main) {
      var cls = String(main.className || '');
      var m = cls.match(/theme-template-suffix-([a-z0-9-]+)/i);
      if (m && m[1] && m[1] !== 'none') return m[1].toLowerCase();
    }
    var root = document.querySelector('[data-wb-coral-hub="1"]');
    if (root) {
      var s = root.getAttribute('data-wb-template-suffix');
      if (s) return String(s).toLowerCase();
    }
    return '';
  }

  /** Only the three hub product handles — never city …-in-… PDPs. */
  var HUB_HANDLES = {
    'mosaic-lamp-workshop': true,
    'ceramic-painting-workshop': true,
    'resin-art-workshop': true,
  };

  function productHandle(booking) {
    if (!booking || !booking.getAttribute) return '';
    return String(booking.getAttribute('data-product-handle') || '')
      .trim()
      .toLowerCase();
  }

  function isCoralHub(booking) {
    var handle = productHandle(booking);
    if (!handle || !HUB_HANDLES[handle]) return false;
    if (booking.getAttribute && booking.getAttribute('data-wb-coral-hub') === '1') return true;
    return Object.prototype.hasOwnProperty.call(CORAL_SUFFIXES, templateSuffix());
  }

  function typeCollectionHandle(booking) {
    if (booking && booking.getAttribute) {
      var h = booking.getAttribute('data-wb-type-collection');
      if (h) return String(h).trim();
    }
    return CORAL_SUFFIXES[templateSuffix()] || '';
  }

  /** City-product handle prefixes for each typed hub collection. */
  function typeCityHandlePrefixes(typeHandle) {
    var t = String(typeHandle || '')
      .trim()
      .toLowerCase();
    if (t === 'mosaic-workshops') {
      return [
        'mosaic-classes-',
        'mosaic-lamp-workshop-',
        'mosaic-classess-',
        'mosaic-classess-in-',
      ];
    }
    if (t === 'ceramic-workshops') {
      return [
        'ceramic-painting-classes-',
        'ceramic-painting-workshop-',
        'ceramic-painting-classes-in-',
      ];
    }
    if (t === 'resin-workshops') {
      return ['resin-classes-', 'resin-art-workshop-'];
    }
    return [];
  }

  function isTypeCityProductHandle(handle, typeHandle) {
    var h = String(handle || '')
      .trim()
      .toLowerCase();
    if (!h || HUB_HANDLES[h]) return false;
    var prefixes = typeCityHandlePrefixes(typeHandle);
    for (var i = 0; i < prefixes.length; i++) {
      if (h.indexOf(prefixes[i]) === 0) return true;
    }
    return false;
  }

  function shopDomain() {
    if (global.Shopify && global.Shopify.shop) return String(global.Shopify.shop);
    return '';
  }

  function apiBase() {
    var raw =
      (typeof global.__AOGEN_API_BASE__ === 'string' && global.__AOGEN_API_BASE__.trim()) ||
      (typeof global.__WB_FORMS_API_BASE__ === 'string' && global.__WB_FORMS_API_BASE__.trim()) ||
      '';
    return String(raw || 'https://adapter.aogen.com.au').replace(/\/+$/, '');
  }

  /**
   * Locale-agnostic catalog root. Under /fr, Shopify.routes.root is "/fr/" and
   * collections/.../products.json returns Translate & Adapt titles/handles
   * (many cities wrongly titled "… à Cambridge"). Venue labels need EN handles.
   */
  function catalogRootPath() {
    return '/';
  }

  function coralHubJsonUrl(handle, page) {
    var base = catalogRootPath().replace(/\/?$/, '/');
    return (
      base +
      'collections/' +
      encodeURIComponent(handle) +
      '?view=coral-hub-json&page=' +
      encodeURIComponent(String(page))
    );
  }

  function collectionProductsJsonUrl(handle, page, limit) {
    var base = catalogRootPath().replace(/\/?$/, '/');
    return (
      base +
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      encodeURIComponent(String(limit || PAGE_SIZE)) +
      '&page=' +
      encodeURIComponent(String(page))
    );
  }

  /**
   * Venue card labels must stay English (city/place names), even on /fr.
   * Shopify Translate & Adapt rewrites product titles (London → Londres); handles do not.
   */
  function titleCaseHandleSlug(slug) {
    return String(slug || '')
      .split('-')
      .filter(Boolean)
      .map(function (w) {
        if (/^[a-z]{2}$/i.test(w)) return w.toUpperCase();
        if (w === 'st' || w === 'ste') return w.charAt(0).toUpperCase() + w.slice(1) + '.';
        return w.charAt(0).toUpperCase() + w.slice(1);
      })
      .join(' ')
      .replace(/\bSt\.\b/g, 'St.')
      .replace(/\bSte\.\b/g, 'Ste.');
  }

  function venueLabelFromHandle(handle) {
    var h = String(handle || '')
      .toLowerCase()
      .trim();
    if (!h) return '';
    /* Longer `-in-` prefixes first — else `…-workshop-` leaves `in-vaughan` → "IN Vaughan". */
    var prefixes = [
      'mosaic-lamp-workshop-in-',
      'mosaic-lamp-workshop-',
      'mosaic-classes-in-',
      'mosaic-classes-',
      'mosaic-classess-in-',
      'mosaic-classess-',
      'ceramic-painting-workshop-in-',
      'ceramic-painting-workshop-',
      'ceramic-painting-classes-in-',
      'ceramic-painting-classes-',
      'resin-art-workshop-in-',
      'resin-art-workshop-',
      'resin-classes-in-',
      'resin-classes-',
    ];
    var rest = '';
    for (var i = 0; i < prefixes.length; i++) {
      if (h.indexOf(prefixes[i]) === 0) {
        rest = h.slice(prefixes[i].length);
        break;
      }
    }
    if (!rest) {
      var m = h.match(/-in-(.+)$/);
      if (m) rest = m[1];
    }
    if (!rest) return '';
    /* Safety: leftover English "in-" from a short prefix match. */
    if (rest.indexOf('in-') === 0) rest = rest.slice(3);
    rest = rest.replace(/-venue-.*$/, '');
    return titleCaseHandleSlug(rest);
  }

  function venueLabelFromTitle(title) {
    var t = String(title || '').trim();
    if (!t) return '';
    var lower = t.toLowerCase();
    var seps = [' in ', ' à ', ' a '];
    for (var i = 0; i < seps.length; i++) {
      var idx = lower.lastIndexOf(seps[i]);
      if (idx > 0) return t.slice(idx + seps[i].length).trim();
    }
    return '';
  }

  /** Undo common FR city localizations when title-parse is the only source. */
  function unlocalizeCityLabel(label) {
    var raw = String(label || '').trim();
    if (!raw) return '';
    var comma = raw.indexOf(',');
    var city = (comma >= 0 ? raw.slice(0, comma) : raw).trim();
    var rest = comma >= 0 ? raw.slice(comma) : '';
    var map = {
      londres: 'London',
      'new york': 'New York',
    };
    var key = city.toLowerCase();
    if (map[key]) return map[key] + rest;
    return raw;
  }

  function stableVenueLabel(p) {
    var fromHandle = venueLabelFromHandle(p && p.handle);
    if (fromHandle) return fromHandle;
    var fromTitle = unlocalizeCityLabel(venueLabelFromTitle(p && p.title));
    if (fromTitle) return fromTitle;
    return String((p && (p.venue_name || p.title)) || '').trim();
  }

  function mapProductsJsonRow(p) {
    var title = String(p.title || '');
    var venueName = stableVenueLabel(p) || title;
    return {
      id: p.id,
      product_gid: 'gid://shopify/Product/' + p.id,
      handle: p.handle,
      title: title,
      venue_gid: '',
      venue_name: venueName,
      lat: '',
      lng: '',
      // Hub cards use venue metaobject images (catalog enrich), not product media.
      image: null,
      facility_options: [],
    };
  }

  function fetchCollectionPage(handle, page) {
    // Prefer products.json (CDN, fast). coral-hub-json is optional enrich for lat/address.
    return fetch(collectionProductsJsonUrl(handle, page, PAGE_SIZE), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('coral_hub_products_json_http_' + res.status);
      return res.json().then(function (body) {
        var list = (body && body.products) || [];
        return {
          ok: true,
          handle: handle,
          page: page,
          pages: null,
          products: list.map(mapProductsJsonRow),
        };
      });
    });
  }

  /** Skip venues whose availability is still unknown. */
  function venuesForPaint(venues, includeWaitlist) {
    var out = [];
    (venues || []).forEach(function (v) {
      if (!v) return;
      if (isCoralStoreVenue(v)) {
        out.push(v);
        return;
      }
      // Catalog-only waitlist stubs (no city product gid) paint as waitlist.
      if (!v._wbAvailabilityKnown) {
        if (v._wbWaitlistVenue === true && !String(v.sell_product_gid || v.product_gid || '').trim()) {
          v._wbAvailabilityKnown = true;
        } else {
          return;
        }
      }
      if (coralHasBookableEvents(v)) out.push(v);
      else if (includeWaitlist) out.push(v);
    });
    return sortCoralVenues(out);
  }

  function catalogRowToHubVenue(row) {
    if (!row) return null;
    var ref = String(row.venue_ref_id || '').trim();
    if (!ref) return null;
    var catName = String(row.venue_name || row.name || row.city || '').trim();
    var lat = Number(row.lat != null ? row.lat : row.latitude);
    var lng = Number(row.lng != null ? row.lng : row.longitude);
    var addr = String(row.venue_address || row.address || '').trim();
    var img = String(row.venue_image || row.image || row.cover_image || '').trim();
    var region = String(row.region_code || row.state_code || '').trim();
    var vHandle = String(row.venue_handle || row.handle || '').trim();
    return markStoreFlag({
      venue_ref_id: ref,
      venue_name: catName || 'Venue',
      name: catName || 'Venue',
      venue_handle: vHandle,
      handle: vHandle,
      address: addr,
      venue_address: addr,
      has_events: false,
      events: [],
      events_count: 0,
      lat: Number.isFinite(lat) ? lat : null,
      lng: Number.isFinite(lng) ? lng : null,
      image: img || null,
      image_url: img || null,
      venue_image: img || null,
      facility_options: Array.isArray(row.facility_options) ? row.facility_options : [],
      sell_product_gid: '',
      sell_product_handle: '',
      product_gid: '',
      product_handle: '',
      region_code: region,
      state_code: region,
      _coral_hub: true,
      _coral_venue_optional: false,
      _wbWaitlistVenue: true,
      _wbAvailabilityKnown: true,
    });
  }

  /** Primary hub inventory: every shop `venue` metaobject (product optional). */
  function hubVenuesFromCatalog(booking) {
    var rows = readWaitlistCatalog(booking);
    var out = [];
    var seenRef = Object.create(null);
    (rows || []).forEach(function (row) {
      var stub = catalogRowToHubVenue(row);
      if (!stub) return;
      var ref = String(stub.venue_ref_id || '').trim();
      if (seenRef[ref]) return;
      seenRef[ref] = true;
      out.push(stub);
    });
    return out;
  }

  function productCitySlug(handle) {
    var h = String(handle || '')
      .trim()
      .toLowerCase();
    if (!h) return '';
    var prefixes = []
      .concat(typeCityHandlePrefixes('mosaic-workshops'))
      .concat(typeCityHandlePrefixes('ceramic-workshops'))
      .concat(typeCityHandlePrefixes('resin-workshops'));
    for (var i = 0; i < prefixes.length; i++) {
      if (h.indexOf(prefixes[i]) === 0) {
        return h.slice(prefixes[i].length).replace(/-venue-.*$/, '');
      }
    }
    var m = h.match(/-in-(.+)$/);
    return m ? String(m[1] || '').replace(/-venue-.*$/, '') : '';
  }

  function slugKey(s) {
    return foldAscii(s)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /** "Halifax, NS" / "Halifax NS" → "halifax" for catalog↔product merge. */
  function cityBaseKey(name) {
    var n = normName(name);
    if (!n) return '';
    var comma = n.indexOf(',');
    if (comma >= 0) n = n.slice(0, comma).trim();
    var parts = n.split(/\s+/).filter(Boolean);
    if (parts.length >= 2 && parts[parts.length - 1].length === 2) {
      parts = parts.slice(0, -1);
    }
    return parts.join(' ');
  }

  function mergeHubVenueFields(target, src) {
    if (!target || !src) return target;
    var gid = String(src.sell_product_gid || src.product_gid || '').trim();
    if (gid) {
      target.sell_product_gid = gid;
      target.product_gid = gid;
    }
    var ph = String(src.product_handle || src.sell_product_handle || '').trim();
    if (ph) {
      target.product_handle = ph;
      target.sell_product_handle = ph;
    }
    var srcRef = String(src.venue_ref_id || '').trim();
    var tgtRef = String(target.venue_ref_id || '').trim();
    var tgtFake = !tgtRef || tgtRef.indexOf('product:') === 0;
    if (srcRef && srcRef.indexOf('product:') !== 0 && tgtFake) {
      target.venue_ref_id = srcRef;
      target._coral_venue_optional = false;
    }
    if (!target.venue_image && src.venue_image) {
      target.venue_image = src.venue_image;
      target.image = src.venue_image;
      target.image_url = src.venue_image;
    }
    if (src.has_events === true) {
      target.has_events = true;
      target._wbWaitlistVenue = false;
      if (Array.isArray(src.events) && src.events.length) target.events = src.events;
    }
    if (src._wbAvailabilityKnown === true) target._wbAvailabilityKnown = true;
    target._coral_hub = true;
    return target;
  }

  /**
   * Bind city products onto catalog venues (by ref / city / handle slug).
   * Unmatched products still append (legacy rows without a venue metaobject).
   */
  function attachProductsOntoCatalogVenues(catalogVenues, productVenues) {
    var list = (catalogVenues || []).slice();
    var byRef = Object.create(null);
    var byCity = Object.create(null);
    var bySlug = Object.create(null);

    function indexVenue(v) {
      if (!v) return;
      var ref = String(v.venue_ref_id || '').trim();
      if (ref && ref.indexOf('product:') !== 0) {
        byRef[ref] = v;
        var m = ref.match(/(\d+)$/);
        if (m) byRef[m[1]] = v;
      }
      var city = cityBaseKey(v.venue_name || v.name || '');
      if (city) byCity[city] = v;
      var vh = slugKey(v.venue_handle || v.handle || '');
      if (vh) bySlug[vh] = v;
      if (city) bySlug[slugKey(city)] = v;
    }

    list.forEach(indexVenue);

    function findCatalogMatch(p) {
      if (!p) return null;
      var ref = String(p.venue_ref_id || '').trim();
      if (ref && ref.indexOf('product:') !== 0) {
        var byR = byRef[ref] || byRef[(ref.match(/(\d+)$/) || [])[1] || ''];
        if (byR) return byR;
      }
      var city = cityBaseKey(p.venue_name || p.name || '');
      if (city && byCity[city]) return byCity[city];
      var slug = productCitySlug(p.product_handle || p.sell_product_handle || '');
      if (!slug) return null;
      var candidates = [slug, slug.replace(/^saint-/, 'st-'), slug.replace(/^st-/, 'saint-')];
      for (var i = 0; i < candidates.length; i++) {
        var c = candidates[i];
        if (!c) continue;
        if (bySlug[c]) return bySlug[c];
        var cn = cityBaseKey(titleCaseHandleSlug(c));
        if (cn && byCity[cn]) return byCity[cn];
      }
      return null;
    }

    (productVenues || []).forEach(function (p) {
      if (!p) return;
      var match = findCatalogMatch(p);
      if (!match) {
        list.push(p);
        indexVenue(p);
        return;
      }
      mergeHubVenueFields(match, p);
      if (String(match.sell_product_gid || '').trim()) match._wbAvailabilityKnown = false;
    });
    return dedupeVenues(list);
  }

  /** Ordered buffer (stores → sessions → waitlist). One paint after background fetch. */
  function commitReadyList(booking, venues) {
    var prevShown = Number(booking.__wbCoralVisibleCount) || 0;
    // Catalog is source of truth; enrich only fills product rows that lack venue fields.
    var stamped = enrichVenuesFromCatalog(booking, venues || []);
    var all = venuesForPaint(stamped, true);
    clearCoralSkeleton(booking);
    booking.__wbCoralAllVenues = all;
    booking.__wbCoralSearchCatalog = all.slice();
    booking.__wbCoralSearchWarmDone = true;
    booking.__wbCoralNextPage = 0;
    booking.__wbCoralCatalogReady = true;
    booking.__wbCoralBootLoading = false;
    booking.__wbCoralVisibleCount = Math.min(
      all.length,
      Math.max(prevShown, Math.min(INITIAL_TARGET, all.length))
    );
    ensureUrlDeepLinkVenueVisible(booking);
    paintVisibleVenues(booking);
    bindInfiniteScroll(booking);
    booking.__wbCoralLoading = false;
  }

  function bootList(booking) {
    var handle = typeCollectionHandle(booking);
    if (!handle) return Promise.reject(new Error('coral_hub_collection_missing'));
    booking.__wbCoralHub = true;
    booking.__wbCoralCollectionHandle = handle;
    booking.__wbCoralNextPage = 0;
    booking.__wbCoralPages = null;
    booking.__wbCoralLoading = false;
    booking.__wbCoralBootLoading = true;
    booking.__wbCoralExhausted = false;
    booking.__wbCoralCatalogReady = false;
    booking.__wbCoralVenues = [];
    booking.__wbCoralAllVenues = [];
    booking.__wbCoralVisibleCount = 0;

    var seed = readLiquidSeed(booking);
    // Venues first — product may be missing/broken; still show waitlist card.
    var catalogBase = hubVenuesFromCatalog(booking);

    booking.__wbCoralLoading = true;
    return fetchHubTypeVenues(handle)
      .then(function (pageVenues) {
        var products = dedupeVenues((seed || []).concat(pageVenues || []));
        var merged = attachProductsOntoCatalogVenues(catalogBase, products);
        // No catalog (empty liquid) → fall back to products only.
        if (!merged.length) merged = products;
        return enrichVenuesAvailability(merged).then(function () {
          commitReadyList(booking, merged);
        });
      })
      .catch(function () {
        booking.__wbCoralBootLoading = false;
        booking.__wbCoralCatalogReady = true;
        booking.__wbCoralLoading = false;
        clearCoralSkeleton(booking);
        var fallback = dedupeVenues((catalogBase || []).concat(seed || []));
        if (fallback.length) {
          commitReadyList(booking, fallback);
        } else {
          paintVisibleVenues(booking);
        }
      })
      .then(function () {
        return booking.__wbCoralVenues || [];
      });
  }

  /** Scroll only reveals more of the already-sorted buffer (+12). */
  function loadMore(booking) {
    if (!booking || booking.__wbCoralLoading || booking.__wbCoralBootLoading) {
      return Promise.resolve([]);
    }
    var all = booking.__wbCoralAllVenues || [];
    var shown = Number(booking.__wbCoralVisibleCount) || 0;
    if (shown >= all.length) {
      booking.__wbCoralExhausted = true;
      booking.__wbCoralCatalogReady = true;
      return Promise.resolve([]);
    }
    booking.__wbCoralLoading = true;
    var next = Math.min(all.length, shown + PAGE_SIZE);
    booking.__wbCoralVisibleCount = next;
    paintVisibleVenues(booking);
    booking.__wbCoralLoading = false;
    return Promise.resolve(all.slice(shown, next));
  }

  function coralVenueSortName(v) {
    return foldAscii(String((v && (v.venue_name || v.name)) || '').trim());
  }

  function coralCityBase(name) {
    var n = foldAscii(String(name || ''))
      .trim()
      .toLowerCase();
    if (!n) return '';
    var comma = n.indexOf(',');
    if (comma >= 0) n = n.slice(0, comma).trim();
    return n;
  }

  function storePinRank(v) {
    if (!v) return -1;
    var base = coralCityBase(coralVenueSortName(v));
    var handle = String(v.product_handle || v.sell_product_handle || '')
      .trim()
      .toLowerCase();
    for (var i = 0; i < STORE_CITIES.length; i++) {
      var city = String(STORE_CITIES[i]).toLowerCase();
      var slug = city.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      if (base === city) return i;
      if (!handle || !slug) continue;
      /* Center: …-in-{city}; Canada: …-{city} / …-venue-{city} */
      if (handle.indexOf('-in-' + slug) >= 0) return i;
      if (handle === slug || handle.indexOf('-' + slug) >= 0) return i;
    }
    return -1;
  }

  function isCoralStoreVenue(v) {
    return storePinRank(v) >= 0;
  }

  function coralHasBookableEvents(v) {
    if (!v) return false;
    if (v._wbWaitlistVenue === true) return false;
    // Hub "has events" = upcoming/bookable only (ended/past → waitlist).
    if (v.has_events !== true) return false;
    var next = String(v.next_date_key || '').trim();
    if (next) {
      var today = new Date();
      var todayKey =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1 < 10 ? '0' : '') +
        (today.getMonth() + 1) +
        '-' +
        (today.getDate() < 10 ? '0' : '') +
        today.getDate();
      if (next < todayKey) return false;
    }
    return true;
  }

  /**
   * Hub order (initial open):
   * 1) stores with upcoming events (Vaughan pin)
   * 2) other venues with upcoming events — A→Z
   * 3) waitlist / no upcoming (incl. waitlist stores) — A→Z
   * Waitlist stores are NOT pinned to the top.
   */
  function sortCoralVenues(venues) {
    return (venues || []).slice().sort(function (a, b) {
      var aEv = coralHasBookableEvents(a) ? 0 : 1;
      var bEv = coralHasBookableEvents(b) ? 0 : 1;
      if (aEv !== bEv) return aEv - bEv;

      // Pin stores only inside the upcoming-events group.
      if (aEv === 0 && bEv === 0) {
        var aRank = storePinRank(a);
        var bRank = storePinRank(b);
        var aStore = aRank >= 0 ? 0 : 1;
        var bStore = bRank >= 0 ? 0 : 1;
        if (aStore !== bStore) return aStore - bStore;
        if (aRank >= 0 && bRank >= 0 && aRank !== bRank) return aRank - bRank;
      }

      return coralVenueSortName(a).localeCompare(coralVenueSortName(b), undefined, {
        sensitivity: 'base',
      });
    });
  }

  function markStoreFlag(v) {
    if (!v) return v;
    if (isCoralStoreVenue(v)) {
      v._coral_store = true;
      v.venue_type = 'store';
    } else {
      v._coral_store = false;
      if (!v.venue_type) v.venue_type = 'popup';
    }
    return v;
  }

  function productToVenue(p) {
    var venueGid = String(p.venue_gid || '').trim();
    // Prefer handle-stable English place name — never localized product title.
    var name =
      stableVenueLabel(p) ||
      String(p.venue_name || '').trim() ||
      String(p.title || '').trim() ||
      'Venue';
    var address = String(p.address || p.venue_address || p.map_location_address || '').trim();
    var lat = Number(p.lat);
    var lng = Number(p.lng);
    var facilities = p.facility_options;
    if (typeof facilities === 'string') {
      try {
        facilities = JSON.parse(facilities);
      } catch (e) {
        facilities = [];
      }
    }
    if (!Array.isArray(facilities)) facilities = [];
    // venue_gid optional when products.json fallback — calendar uses product_gid only.
    if (!venueGid) venueGid = 'product:' + String(p.product_gid || p.id || name);
    return markStoreFlag({
      venue_ref_id: venueGid,
      venue_name: name,
      name: name,
      address: address,
      venue_address: address,
      has_events: false,
      events: [],
      events_count: 0,
      lat: Number.isFinite(lat) ? lat : null,
      lng: Number.isFinite(lng) ? lng : null,
      image: null,
      image_url: null,
      venue_image: null,
      facility_options: facilities,
      sell_product_gid: String(p.product_gid || '').trim(),
      sell_product_handle: String(p.handle || '').trim(),
      product_gid: String(p.product_gid || '').trim(),
      product_handle: String(p.handle || '').trim(),
      _coral_hub: true,
      _coral_venue_optional: String(p.venue_gid || '').trim() === '',
    });
  }

  function venuesToList(venues) {
    return {
      groups: [
        {
          key: 'coral-hub',
          label: 'Venues',
          venues: venues,
        },
      ],
    };
  }

  function readWaitlistCatalog(booking) {
    if (!booking || !booking.querySelector) return [];
    var el = booking.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
    if (!el || !el.textContent) return [];
    try {
      var raw = JSON.parse(String(el.textContent || '').trim() || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function foldAscii(s) {
    try {
      return String(s || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    } catch (e) {
      return String(s || '');
    }
  }

  function normName(s) {
    return foldAscii(s)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /** Fill address/lat/lng/venue_ref_id from Liquid venue catalog (metaobjects). */
  function enrichVenuesFromCatalog(booking, venues) {
    var rows = readWaitlistCatalog(booking);
    if (!rows.length || !venues || !venues.length) return venues || [];
    var byRef = Object.create(null);
    var byName = Object.create(null);
    rows.forEach(function (row) {
      if (!row) return;
      var ref = String(row.venue_ref_id || '').trim();
      if (ref) {
        byRef[ref] = row;
        var m = ref.match(/(\d+)$/);
        if (m) byRef[m[1]] = row;
      }
      var n = normName(row.venue_name || row.name || row.city);
      if (n) byName[n] = row;
    });
    venues.forEach(function (v) {
      if (!v) return;
      var ref = String(v.venue_ref_id || v.venue_gid || '').trim();
      var fakeRef = !ref || ref.indexOf('product:') === 0;
      var row =
        (!fakeRef && ref && (byRef[ref] || byRef[(ref.match(/(\d+)$/) || [])[1] || ''])) || null;
      if (!row) row = byName[normName(v.venue_name || v.name)] || null;
      if (!row) return;
      var catRef = String(row.venue_ref_id || '').trim();
      // products.json has no venue metafield — stamp real metaobject GID for ?venue= deep links.
      if (catRef && fakeRef) {
        v.venue_ref_id = catRef;
        v._coral_venue_optional = false;
      }
      var addr = String(row.venue_address || row.address || '').trim();
      if (addr) {
        if (!v.address) v.address = addr;
        if (!v.venue_address) v.venue_address = addr;
      }
      var lat = Number(row.lat != null ? row.lat : row.latitude);
      var lng = Number(row.lng != null ? row.lng : row.longitude);
      if (v.lat == null && Number.isFinite(lat)) v.lat = lat;
      if (v.lng == null && Number.isFinite(lng)) v.lng = lng;
      if (!v.region_code && row.region_code) v.region_code = String(row.region_code).trim();
      if (!v.state_code && (row.state_code || row.region_code)) {
        v.state_code = String(row.state_code || row.region_code).trim();
      }
      // Catalog metaobject names are English — prefer over FR product titles.
      var catName = String(row.venue_name || row.name || row.city || '').trim();
      if (catName) {
        v.venue_name = catName;
        v.name = catName;
      }
      // Venue metaobject image only — never product featured media.
      var catImg = String(row.venue_image || row.image || row.cover_image || '').trim();
      if (catImg) {
        v.venue_image = catImg;
        v.image = catImg;
        v.image_url = catImg;
      } else {
        v.venue_image = null;
        v.image = null;
        v.image_url = null;
      }
    });
    return venues;
  }

  function getUrlVenueToken() {
    try {
      return (new URLSearchParams(global.location.search).get('venue') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function coralVenueMatchesUrlToken(venue, token) {
    if (!venue || !token) return false;
    var H = global.WorkshopBookingWizardHelpers;
    if (H && typeof H.venueMatchesUrlToken === 'function') {
      return H.venueMatchesUrlToken(venue, token);
    }
    var t = String(token).trim().toLowerCase();
    var ref = String(venue.venue_ref_id || '').trim();
    var m = ref.match(/(\d+)$/);
    if (m && String(m[1]) === t) return true;
    if (ref.toLowerCase() === t) return true;
    var name = String(venue.venue_name || venue.name || '')
      .trim()
      .toLowerCase();
    return name === t;
  }

  /** Deep-link ?venue= must be in the painted slice or wizard never selects / never fetches sell variants. */
  function ensureUrlDeepLinkVenueVisible(booking) {
    var token = getUrlVenueToken();
    if (!token || !booking) return false;
    var all = booking.__wbCoralAllVenues || [];
    var idx = -1;
    for (var i = 0; i < all.length; i++) {
      if (coralVenueMatchesUrlToken(all[i], token)) {
        idx = i;
        break;
      }
    }
    if (idx < 0) return false;
    var need = Math.max(Number(booking.__wbCoralVisibleCount) || 0, idx + 1, INITIAL_TARGET);
    booking.__wbCoralVisibleCount = Math.min(all.length, need);
    return true;
  }

  function applyVenueList(booking, venues) {
    venues = enrichVenuesFromCatalog(booking, sortCoralVenues(venues || []));
    var list = venuesToList(venues);
    booking.__wbCoralVenues = venues.slice();
    booking.__wbWizardInitialVenueList = list;
    if (typeof booking.__wbApplyVenueList === 'function') {
      booking.__wbApplyVenueList(list);
      return;
    }
    // Fallback: dispatch for location.js to pick up if wired.
    try {
      booking.dispatchEvent(
        new CustomEvent('wb:coral-hub-venues', { bubbles: true, detail: { venueList: list } })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function dedupeVenues(venues) {
    var byGid = Object.create(null);
    var byRef = Object.create(null);
    var byCity = Object.create(null);
    var out = [];
    (venues || []).forEach(function (v) {
      if (!v) return;
      var gid = String(v.sell_product_gid || v.product_gid || '').trim();
      var ref = String(v.venue_ref_id || '').trim();
      var fakeRef = !ref || ref.indexOf('product:') === 0;
      var city = cityBaseKey(v.venue_name || v.name || '');

      if (gid && byGid[gid]) {
        mergeHubVenueFields(byGid[gid], v);
        return;
      }
      if (!fakeRef && ref && byRef[ref]) {
        mergeHubVenueFields(byRef[ref], v);
        if (gid) byGid[gid] = byRef[ref];
        return;
      }
      // Same city already listed (catalog stub + unmatched product) → one card.
      if (city && byCity[city]) {
        mergeHubVenueFields(byCity[city], v);
        if (gid) byGid[gid] = byCity[city];
        if (!fakeRef && ref) byRef[ref] = byCity[city];
        return;
      }

      if (!gid && !ref && !city) return;
      out.push(v);
      if (gid) byGid[gid] = v;
      if (!fakeRef && ref) byRef[ref] = v;
      if (city) byCity[city] = v;
    });
    return out;
  }

  function paintVisibleVenues(booking) {
    var all = booking.__wbCoralAllVenues || [];
    var shown = Number(booking.__wbCoralVisibleCount) || 0;
    if (shown < 1) shown = Math.min(INITIAL_TARGET, all.length);
    booking.__wbCoralVisibleCount = shown;
    // Exhausted when the sorted buffer is fully revealed (catalog already loaded).
    booking.__wbCoralExhausted =
      booking.__wbCoralCatalogReady === true && shown >= all.length && !booking.__wbCoralBootLoading;
    applyVenueList(booking, all.slice(0, shown));
    reconnectScrollObserver(booking);
    return all.slice(0, shown);
  }

  function collectionCountJsonUrl(handle) {
    var base = catalogRootPath().replace(/\/?$/, '/');
    return base + 'collections/' + encodeURIComponent(handle) + '.json';
  }

  function fetchCollectionPageCount(handle) {
    return fetch(collectionCountJsonUrl(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) return 8;
        return res.json().then(function (body) {
          var n = Number((body && body.collection && body.collection.products_count) || 0);
          if (!Number.isFinite(n) || n <= 0) return 8;
          return Math.max(1, Math.ceil(n / PAGE_SIZE));
        });
      })
      .catch(function () {
        return 8;
      });
  }

  function mapPageProducts(data) {
    var out = [];
    ((data && data.products) || []).forEach(function (p) {
      var v = productToVenue(p);
      if (v && v.sell_product_gid) out.push(v);
    });
    return out;
  }

  function fetchCollectionPages(handle, pageNums) {
    return Promise.all(
      (pageNums || []).map(function (p) {
        return fetchCollectionPage(handle, p).catch(function () {
          return { products: [] };
        });
      })
    ).then(function (pages) {
      var all = [];
      pages.forEach(function (data) {
        all = all.concat(mapPageProducts(data));
      });
      return dedupeVenues(all);
    });
  }

  function fetchAllCollectionVenues(handle, opts) {
    // Shopify products.json max 250 — one request covers ~95 city products.
    var LIMIT = 250;
    var handlePredicate =
      opts && typeof opts.handlePredicate === 'function' ? opts.handlePredicate : null;

    function fetchPage(page) {
      return fetch(collectionProductsJsonUrl(handle, page, LIMIT), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) return { products: [] };
          return res.json().then(function (body) {
            return { products: ((body && body.products) || []).map(mapProductsJsonRow) };
          });
        })
        .catch(function () {
          return { products: [] };
        });
    }

    function acceptMapped(rows) {
      if (!handlePredicate) return rows;
      return (rows || []).filter(function (v) {
        return handlePredicate(String((v && (v.product_handle || v.sell_product_handle)) || ''));
      });
    }

    return fetchPage(1).then(function (first) {
      var all = acceptMapped(mapPageProducts(first));
      if ((first.products || []).length < LIMIT) return dedupeVenues(all);

      function next(page, acc) {
        return fetchPage(page).then(function (data) {
          var rows = acceptMapped(mapPageProducts(data));
          acc = acc.concat(rows);
          if ((data.products || []).length < LIMIT) return dedupeVenues(acc);
          return next(page + 1, acc);
        });
      }
      return next(2, all);
    });
  }

  /**
   * Typed collection + matching city products from `workshops` (auto/waitlist orphans).
   * Example: mosaic-classes-saint-jerome is in workshops but not mosaic-workshops.
   */
  function fetchHubTypeVenues(typeHandle) {
    var type = String(typeHandle || '').trim();
    if (!type) return Promise.resolve([]);
    return Promise.all([
      fetchAllCollectionVenues(type),
      fetchAllCollectionVenues(ALL_WORKSHOPS_COLLECTION, {
        handlePredicate: function (h) {
          return isTypeCityProductHandle(h, type);
        },
      }).catch(function () {
        return [];
      }),
    ]).then(function (parts) {
      return dedupeVenues((parts[0] || []).concat(parts[1] || []));
    });
  }

  function readLiquidSeed(booking) {
    if (!booking || !booking.querySelector) return [];
    var el = booking.querySelector('script[type="application/json"][data-wb-coral-seed]');
    if (!el || !el.textContent) return [];
    try {
      var raw = JSON.parse(String(el.textContent || '').trim() || '[]');
      if (!Array.isArray(raw)) return [];
      return raw
        .map(function (p) {
          if (!p || !p.id) return null;
          return productToVenue({
            id: p.id,
            product_gid: 'gid://shopify/Product/' + p.id,
            handle: p.handle,
            title: p.title,
            venue_name: p.venue_name || '',
            venue_gid: '',
            image: null,
            facility_options: [],
          });
        })
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function clearCoralSkeleton(booking) {
    if (!booking) return;
    var sk = booking.querySelector('[data-wb-coral-skeleton]');
    if (sk && sk.parentNode) sk.parentNode.removeChild(sk);
  }

  function findScrollRoot(booking) {
    // Wizard Step 1 scrolls inside [data-events-panel="1"] (absolute + overflow-y:auto).
    var preferred = [
      booking.querySelector('[data-events-panel="1"]'),
      booking.querySelector('.workshop-booking-scroll'),
      booking.querySelector('[data-events-list-slot]'),
    ];
    for (var i = 0; i < preferred.length; i++) {
      var el = preferred[i];
      if (!el) continue;
      try {
        var style = global.getComputedStyle(el);
        var oy = style && style.overflowY;
        if (oy === 'auto' || oy === 'scroll' || oy === 'overlay') return el;
      } catch (e) {
        /* ignore */
      }
    }
    // Walk up from the venue list until we hit an overflow scroller.
    var start =
      booking.querySelector('[data-workshop-events]') ||
      booking.querySelector('.wbw-venue-flat-list');
    var node = start;
    while (node && node !== booking.parentElement) {
      if (node.nodeType === 1) {
        try {
          var st = global.getComputedStyle(node);
          var oy2 = st && st.overflowY;
          if (
            (oy2 === 'auto' || oy2 === 'scroll' || oy2 === 'overlay') &&
            node.scrollHeight > node.clientHeight + 4
          ) {
            return node;
          }
        } catch (e2) {
          /* ignore */
        }
      }
      node = node.parentElement;
    }
    return preferred[0] || null;
  }

  function ensureScrollSentinel(booking) {
    var list =
      booking.querySelector('.wbw-venue-flat-list') ||
      booking.querySelector('[data-workshop-events]') ||
      booking.querySelector('.workshop-events-list');
    if (!list) return null;
    var sentinel = booking.__wbCoralSentinel;
    if (!sentinel || !sentinel.isConnected) {
      sentinel = document.createElement('div');
      sentinel.setAttribute('data-wb-coral-sentinel', '1');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText =
        'width:100%;height:64px;pointer-events:none;flex:0 0 auto;grid-column:1/-1;';
      booking.__wbCoralSentinel = sentinel;
    }
    if (sentinel.parentNode !== list) list.appendChild(sentinel);
    return sentinel;
  }

  function distanceToBottom(root) {
    if (root && root.nodeType === 1) {
      return root.scrollHeight - (root.scrollTop + root.clientHeight);
    }
    var doc = global.document.documentElement;
    var body = global.document.body;
    var scrollY = global.pageYOffset || (doc && doc.scrollTop) || 0;
    var vh = global.innerHeight || (doc && doc.clientHeight) || 0;
    var sh = Math.max(
      (doc && doc.scrollHeight) || 0,
      (body && body.scrollHeight) || 0
    );
    return sh - (scrollY + vh);
  }

  function shouldPrefetchMore(booking, root) {
    if (!booking || booking.__wbCoralExhausted || booking.__wbCoralBootLoading) return false;
    var all = booking.__wbCoralAllVenues || [];
    var shown = Number(booking.__wbCoralVisibleCount) || 0;
    if (shown >= all.length) return false;

    // After ready list: only when near bottom of wizard scroller.
    root = root || findScrollRoot(booking);
    if (!root || root.nodeType !== 1) return false;
    var vh = root.clientHeight || 600;
    return distanceToBottom(root) <= Math.max(320, vh * 0.65);
  }

  /** List re-render destroys sentinel; must re-observe + rebind scroll after every paint. */
  function reconnectScrollObserver(booking) {
    if (!booking) return;
    var sentinel = ensureScrollSentinel(booking);
    var root = findScrollRoot(booking) || booking.querySelector('[data-events-panel="1"]');
    booking.__wbCoralScrollRoot = root;

    if (booking.__wbCoralScrollOnScroll) {
      try {
        if (
          booking.__wbCoralScrollRootBound &&
          booking.__wbCoralScrollRootBound !== root
        ) {
          booking.__wbCoralScrollRootBound.removeEventListener(
            'scroll',
            booking.__wbCoralScrollOnScroll
          );
        }
      } catch (e) {
        /* ignore */
      }
      if (root) {
        try {
          root.removeEventListener('scroll', booking.__wbCoralScrollOnScroll);
        } catch (e2) {
          /* ignore */
        }
        root.addEventListener('scroll', booking.__wbCoralScrollOnScroll, { passive: true });
        booking.__wbCoralScrollRootBound = root;
      }
    }

    if (!sentinel) return;
    if (typeof IntersectionObserver === 'function') {
      try {
        if (booking.__wbCoralIO) booking.__wbCoralIO.disconnect();
      } catch (e3) {
        /* ignore */
      }
      booking.__wbCoralIO = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i] && entries[i].isIntersecting) {
              if (typeof booking.__wbCoralScrollMaybeLoad === 'function') {
                booking.__wbCoralScrollMaybeLoad();
              }
              break;
            }
          }
        },
        {
          root: root && root.nodeType === 1 ? root : null,
          rootMargin: '80px 0px',
          threshold: 0,
        }
      );
      booking.__wbCoralIO.observe(sentinel);
    }
  }

  function bindInfiniteScroll(booking) {
    function maybeLoad() {
      if (booking.__wbCoralLoading || booking.__wbCoralBootLoading || booking.__wbCoralExhausted) {
        return;
      }
      var root =
        findScrollRoot(booking) ||
        booking.querySelector('[data-events-panel="1"]') ||
        booking.__wbCoralScrollRoot;
      booking.__wbCoralScrollRoot = root;
      if (!shouldPrefetchMore(booking, root)) return;
      loadMore(booking)
        .then(function () {
          if (booking.__wbCoralExhausted) return;
          if (shouldPrefetchMore(booking, booking.__wbCoralScrollRoot || root)) {
            global.setTimeout(maybeLoad, 80);
          }
        })
        .catch(function () {});
    }
    booking.__wbCoralScrollMaybeLoad = maybeLoad;
    booking.__wbCoralScrollOnScroll = function () {
      maybeLoad();
    };

    if (!booking.__wbCoralScrollBound) {
      booking.__wbCoralScrollBound = true;
    }
    reconnectScrollObserver(booking);
  }

  function monthBounds(year, month1to12) {
    var Cal = global.WorkshopBookingCalendarWindow;
    if (Cal && typeof Cal.monthDateBounds === 'function') return Cal.monthDateBounds(year, month1to12);
    var pad = function (n) {
      return (n < 10 ? '0' : '') + n;
    };
    var last = new Date(year, month1to12, 0).getDate();
    return {
      from: year + '-' + pad(month1to12) + '-01',
      to: year + '-' + pad(month1to12) + '-' + pad(last),
    };
  }

  function windowBounds(year, month1to12, lookahead) {
    var Cal = global.WorkshopBookingCalendarWindow;
    if (Cal && typeof Cal.windowDateBounds === 'function') {
      return Cal.windowDateBounds(year, month1to12, lookahead);
    }
    var start = monthBounds(year, month1to12);
    var endYmMonth = month1to12 + Number(lookahead || 0);
    var y = year;
    while (endYmMonth > 12) {
      endYmMonth -= 12;
      y += 1;
    }
    var end = monthBounds(y, endYmMonth);
    return { from: start.from, to: end.to };
  }

  function fetchEventsBatch(opts) {
    var url = apiBase() + '/api/public/workshop-venue/events-batch';
    var gids = Array.isArray(opts.productGids)
      ? opts.productGids
      : opts.productGid
        ? [opts.productGid]
        : [];
    gids = gids
      .map(function (g) {
        return String(g || '').trim();
      })
      .filter(Boolean);
    var body = {
      shop_domain: shopDomain(),
      product_gids: gids,
      date_from: opts.dateFrom,
      date_to: opts.dateTo,
    };
    if (opts.horizonDays != null && Number(opts.horizonDays) > 0) {
      body.horizon_days = Number(opts.horizonDays);
      delete body.date_from;
      delete body.date_to;
    }
    if (opts.maxSlotsPerProduct != null && Number(opts.maxSlotsPerProduct) > 0) {
      body.max_slots_per_product = Math.floor(Number(opts.maxSlotsPerProduct));
    }
    if (opts.presenceOnly === true) {
      body.presence_only = true;
    }
    var vref = String(opts.venueRefId || '').trim();
    if (vref && vref.indexOf('product:') !== 0) {
      body.venue_ref_ids = [vref];
    }
    return fetch(url, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      signal: opts.signal,
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || !json || json.ok === false) {
          var err = new Error((json && json.description) || 'events_batch_failed');
          err.status = res.status;
          err.body = json;
          throw err;
        }
        return json;
      });
    });
  }

  function slotsToEvents(batchBody, venueRefId) {
    var products = (batchBody && batchBody.products) || [];
    var out = [];
    // products.json has no venue metafield → venue_ref_id is "product:<gid>".
    // Do not filter slots against that fake id (API returns real metaobject GIDs).
    var fakeVenue = !venueRefId || String(venueRefId).indexOf('product:') === 0;
    products.forEach(function (row) {
      (row.slots || []).forEach(function (slot) {
        if (!slot) return;
        if (
          !fakeVenue &&
          venueRefId &&
          slot.venue_ref_id &&
          String(slot.venue_ref_id) !== String(venueRefId)
        ) {
          return;
        }
        var alsoAvailable = Array.isArray(slot.also_available_products)
          ? slot.also_available_products
          : Array.isArray(slot.alsoAvailableProducts)
            ? slot.alsoAvailableProducts
            : [];
        var availableVariants = Array.isArray(slot.available_variants)
          ? slot.available_variants
          : Array.isArray(slot.availableVariants)
            ? slot.availableVariants
            : [];
        var slotVenueRef = String(slot.venue_ref_id || '').trim();
        out.push({
          id: slot.event_id,
          gid: slot.event_id,
          event_id: slot.event_id,
          handle: String(slot.handle || '').trim(),
          date_key: slot.date_key,
          starts_at: slot.starts_at,
          schema_start: slot.schema_start || slot.starts_at || '',
          schema_end: slot.schema_end || slot.ends_at || '',
          time_label: slot.time_label,
          // Keep selected coral venue key so calendar attaches to the card.
          venue_ref_id: fakeVenue ? venueRefId : slotVenueRef || venueRefId,
          // Real metaobject venue id from API — Also available / index lookup (not product:…).
          api_venue_ref_id: slotVenueRef,
          venue_name: slot.venue_name || '',
          city: slot.city || slot.city_name || '',
          status: slot.status || 'active',
          display_status: slot.display_status || 'bookable',
          capacity_remaining: slot.capacity_remaining,
          canonical_event_id: slot.canonical_event_id,
          capacity_group_id: slot.capacity_group_id,
          product_gid: row.product_gid,
          product_handle: row.product_handle,
          // Center normalizeApiEvent keeps these on the event → wizard slot._raw
          // (Also available sibling promo + variant grid).
          also_available_products: alsoAvailable,
          available_variants: availableVariants,
        });
      });
    });
    return out;
  }

  /** Stamp has_events / next_date. Chunks run in parallel; caller paints once after. */
  function enrichVenuesAvailability(venues) {
    var list = venues || [];
    if (!list.length) return Promise.resolve(list);
    var CHUNK = 24;
    var gids = [];
    var seen = Object.create(null);
    var byGid = Object.create(null);
    var ordered = list.slice().sort(function (a, b) {
      var aS = isCoralStoreVenue(a) ? 0 : 1;
      var bS = isCoralStoreVenue(b) ? 0 : 1;
      return aS - bS;
    });
    ordered.forEach(function (v) {
      var g = String((v && (v.sell_product_gid || v.product_gid)) || '').trim();
      if (!g) return;
      if (!byGid[g]) byGid[g] = [];
      byGid[g].push(v);
      if (seen[g]) return;
      seen[g] = true;
      gids.push(g);
    });
    if (!gids.length) return Promise.resolve(list);
    var chunks = [];
    for (var i = 0; i < gids.length; i += CHUNK) chunks.push(gids.slice(i, i + CHUNK));
    var today = new Date();
    var todayKey =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1 < 10 ? '0' : '') +
      (today.getMonth() + 1) +
      '-' +
      (today.getDate() < 10 ? '0' : '') +
      today.getDate();

    var nowMs = Date.now();

    function isUpcomingBookableSlot(slot) {
      if (!slot) return false;
      var ds = String(slot.display_status || slot.status || '')
        .trim()
        .toLowerCase();
      if (
        ds === 'ended' ||
        ds === 'completed' ||
        ds === 'past' ||
        ds === 'cancelled' ||
        ds === 'canceled' ||
        ds === 'hidden' ||
        ds === 'draft' ||
        ds === 'sold_out'
      ) {
        return false;
      }
      // Only treat clearly bookable statuses as "has upcoming events".
      if (ds && ds !== 'bookable' && ds !== 'active' && ds !== 'available' && ds !== 'open') {
        return false;
      }
      var dk = String(slot.date_key || '').trim();
      if (dk && dk < todayKey) return false;
      var starts = String(slot.starts_at || '').trim();
      if (starts) {
        var t = Date.parse(starts);
        if (Number.isFinite(t) && t < nowMs) return false;
      }
      if (!dk && !starts) return false;
      // presence_only responses omit capacity_remaining — treat null as ok.
      if (slot.capacity_remaining != null && Number(slot.capacity_remaining) <= 0) return false;
      return true;
    }

    function firstFutureSlot(slots) {
      var rows = (slots || []).slice().sort(function (a, b) {
        return String((a && (a.starts_at || a.date_key)) || '').localeCompare(
          String((b && (b.starts_at || b.date_key)) || '')
        );
      });
      for (var si = 0; si < rows.length; si++) {
        if (isUpcomingBookableSlot(rows[si])) return rows[si];
      }
      return null;
    }

    function stampGids(chunkGids, slotsByGid) {
      chunkGids.forEach(function (g) {
        var first = firstFutureSlot((g && slotsByGid[g]) || []);
        (byGid[g] || []).forEach(function (v) {
          if (!v) return;
          v._wbAvailabilityKnown = true;
          if (!first) {
            v.has_events = false;
            v.events_count = 0;
            v._wbWaitlistVenue = true;
            v.events = [];
            v.next_date_key = '';
            return;
          }
          v.has_events = true;
          v.events_count = 1;
          v._wbWaitlistVenue = false;
          v.next_date_key = String(first.date_key || '').trim();
          v.events = slotsToEvents(
            { products: [{ product_gid: g, product_handle: v.product_handle || null, slots: [first] }] },
            v.venue_ref_id
          );
        });
      });
    }

    return Promise.all(
      chunks.map(function (chunk) {
        return fetchEventsBatch({
          productGids: chunk,
          horizonDays: 120,
          // Fetch a few slots so an ended/past first row does not hide a later upcoming one.
          maxSlotsPerProduct: 8,
          presenceOnly: true,
        })
          .catch(function () {
            return null;
          })
          .then(function (json) {
            var slotsByGid = Object.create(null);
            if (json && Array.isArray(json.products)) {
              json.products.forEach(function (row) {
                var pg = String((row && row.product_gid) || '').trim();
                if (!pg) return;
                slotsByGid[pg] = Array.isArray(row.slots) ? row.slots : [];
              });
            }
            if (!json) {
              chunk.forEach(function (g) {
                slotsByGid[g] = [];
              });
            }
            stampGids(chunk, slotsByGid);
          });
      })
    ).then(function () {
      return list;
    });
  }

  /**
   * Calendar fetch for coral: single city product + venue + date window via events-batch.
   */
  function fetchVenueCalendar(booking, venue, dateFrom, dateTo, signal) {
    var productGid = String(
      (venue && (venue.sell_product_gid || venue.product_gid)) || ''
    ).trim();
    var venueRefId = String((venue && venue.venue_ref_id) || '').trim();
    if (!productGid) return Promise.reject(new Error('coral_hub_product_gid_missing'));
    if (!venueRefId) return Promise.reject(new Error('coral_hub_venue_ref_missing'));
    return fetchEventsBatch({
      productGid: productGid,
      venueRefId: venueRefId,
      dateFrom: dateFrom,
      dateTo: dateTo,
      signal: signal,
    }).then(function (body) {
      return slotsToEvents(body, venueRefId);
    });
  }

  function warmSearchCatalog(booking) {
    var handle = booking.__wbCoralCollectionHandle;
    if (!handle) return Promise.resolve(booking.__wbCoralSearchCatalog || []);
    if (booking.__wbCoralSearchWarmDone && (booking.__wbCoralSearchCatalog || []).length > INITIAL_TARGET) {
      return Promise.resolve(booking.__wbCoralSearchCatalog);
    }
    if (booking.__wbCoralSearchWarmInFlight) return booking.__wbCoralSearchWarmInFlight;
    // Search-only warm: venues catalog first, then bind city products.
    booking.__wbCoralSearchWarmInFlight = fetchHubTypeVenues(handle)
      .then(function (all) {
        var catalogBase = hubVenuesFromCatalog(booking);
        var merged = attachProductsOntoCatalogVenues(catalogBase, dedupeVenues(all || []));
        if (!merged.length) merged = dedupeVenues(all || []);
        var sorted = sortCoralVenues(merged);
        booking.__wbCoralSearchCatalog = sorted;
        booking.__wbCoralSearchWarmDone = true;
        return sorted;
      })
      .catch(function () {
        booking.__wbCoralSearchWarmDone = true;
        return booking.__wbCoralSearchCatalog || [];
      })
      .then(function (rows) {
        booking.__wbCoralSearchWarmInFlight = null;
        return rows;
      });
    return booking.__wbCoralSearchWarmInFlight;
  }

  function selectVenueFromSearch(booking, venue) {
    if (!booking || !venue) return false;
    var gid = String(venue.sell_product_gid || venue.product_gid || '').trim();
    var ref = String(venue.venue_ref_id || '').trim();
    var all = (booking.__wbCoralAllVenues || []).slice();
    var idx = -1;
    for (var i = 0; i < all.length; i++) {
      var g = String((all[i] && (all[i].sell_product_gid || all[i].product_gid)) || '').trim();
      var r = String((all[i] && all[i].venue_ref_id) || '').trim();
      if ((gid && g === gid) || (ref && r === ref)) {
        idx = i;
        break;
      }
    }
    if (idx < 0) {
      all.push(venue);
      all = sortCoralVenues(dedupeVenues(all));
      booking.__wbCoralAllVenues = all;
      booking.__wbCoralSearchCatalog = all.slice();
      for (i = 0; i < all.length; i++) {
        g = String((all[i] && (all[i].sell_product_gid || all[i].product_gid)) || '').trim();
        r = String((all[i] && all[i].venue_ref_id) || '').trim();
        if ((gid && g === gid) || (ref && r === ref)) {
          idx = i;
          break;
        }
      }
    }
    var need = Math.max(Number(booking.__wbCoralVisibleCount) || 0, idx + 1, INITIAL_TARGET);
    booking.__wbCoralVisibleCount = Math.min(all.length, need);
    paintVisibleVenues(booking);
    global.setTimeout(function () {
      var want = String((all[idx] && all[idx].venue_ref_id) || ref || '').trim();
      if (!want) return;
      var card = booking.querySelector(
        '[data-venue-ref-id="' + (global.CSS && CSS.escape ? CSS.escape(want) : want) + '"]'
      );
      if (card && typeof card.click === 'function') card.click();
    }, 30);
    return true;
  }

  function boot(booking) {
    if (!booking || !isCoralHub(booking)) return Promise.resolve(false);
    booking.setAttribute('data-wb-coral-hub', '1');
    var col = typeCollectionHandle(booking);
    if (col) booking.setAttribute('data-wb-type-collection', col);
    return bootList(booking).then(function () {
      // Full catalog for search (grid stays paginated).
      warmSearchCatalog(booking);
      return true;
    });
  }

  function prefetchSellVariants(venue) {
    if (!venue || !venue.sell_product_handle) return Promise.resolve(venue);
    if (venue._sellVariantsLoaded) return Promise.resolve(venue);
    var handle = String(venue.sell_product_handle).trim();
    // Always fetch locale-agnostic /products/*.js — under /fr/ many city
    // products 404 (e.g. mosaic-lamp-workshop-vaughan.js), which empties
    // remap and surfaces "session not available" on Add to cart.
    var url = '/products/' + encodeURIComponent(handle) + '.js';
    venue._sellVariantsLoaded = true;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('sell_product_js_' + res.status);
        return res.json();
      })
      .then(function (prod) {
        var byLabel = Object.create(null);
        var byId = Object.create(null);
        (prod.variants || []).forEach(function (v) {
          var id = String(v.id);
          var label = String(v.option1 || v.title || '')
            .trim()
            .toLowerCase();
          // Prefer an available design match — never overwrite an available
          // id with a later sold-out date×time row that shares option1.
          if (label) {
            var prev = byLabel[label] ? byId[byLabel[label]] : null;
            if (!prev || (v.available !== false && prev.available === false)) {
              byLabel[label] = id;
            }
          }
          byId[id] = v;
        });
        venue._sellVariantByLabel = byLabel;
        venue._sellVariants = prod.variants || [];
        venue.sell_product_id = prod.id;
        return venue;
      })
      .catch(function () {
        venue._sellVariantsLoaded = false;
        return venue;
      });
  }

  var MONTH_LONG = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ];
  var MONTH_SHORT = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
  ];

  function normKey(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function dateHintsFromSlot(slot) {
    var raw = (slot && slot._raw) || slot || {};
    var hints = [];
    var dk = String(raw.date_key || (slot && slot.date_key) || '').trim();
    var m = dk.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      var mi = parseInt(m[2], 10) - 1;
      var day = parseInt(m[3], 10);
      if (mi >= 0 && mi < 12 && day > 0) {
        hints.push(MONTH_LONG[mi] + ' ' + day);
        hints.push(MONTH_SHORT[mi] + ' ' + day);
        hints.push(MONTH_LONG[mi] + ' ' + (day < 10 ? '0' + day : String(day)));
        hints.push(m[2] + '/' + m[3]);
        hints.push(String(parseInt(m[2], 10)) + '/' + day);
      }
    }
    var starts = String(raw.starts_at || (slot && slot.starts_at) || '').trim();
    if (starts) {
      var d = new Date(starts);
      if (!isNaN(d.getTime())) {
        var mi2 = d.getMonth();
        var day2 = d.getDate();
        hints.push(MONTH_LONG[mi2] + ' ' + day2);
        hints.push(MONTH_SHORT[mi2] + ' ' + day2);
      }
    }
    return hints.map(normKey).filter(Boolean);
  }

  function timeHintsFromSlot(slot) {
    var raw = (slot && slot._raw) || slot || {};
    var hints = [];
    var label = String(raw.time_label || (slot && slot.time_label) || '').trim();
    if (label) {
      hints.push(label);
      hints.push(label.replace(/\./g, ''));
      hints.push(label.replace(/\s+/g, ''));
    }
    var starts = String(raw.starts_at || (slot && slot.starts_at) || '').trim();
    if (starts) {
      var d = new Date(starts);
      if (!isNaN(d.getTime())) {
        var h = d.getHours();
        var min = d.getMinutes();
        var h12 = h % 12 || 12;
        var ampm = h < 12 ? 'am' : 'pm';
        var mm = min < 10 ? '0' + min : String(min);
        hints.push(h12 + (min ? ':' + mm : '') + ' ' + ampm);
        hints.push(h12 + ':' + mm + ' ' + ampm);
        hints.push(h12 + ampm);
        if (min === 0) hints.push(h12 + ' ' + ampm);
        hints.push((h < 10 ? '0' : '') + h + ':' + mm);
      }
    }
    return hints.map(normKey).filter(Boolean);
  }

  function variantTextBlob(v) {
    return normKey(
      [v.option1, v.option2, v.option3, v.title, v.name].filter(Boolean).join(' / ')
    );
  }

  /** Collapse hub ↔ city naming drift (Aladdin's Magic Lamp ↔ Aladdin Lamp). */
  function designAliasKey(s) {
    var t = normKey(s)
      .replace(/['’]/g, '')
      .replace(/\bmagic\b/g, ' ')
      .replace(/\bsmall\b/g, ' ')
      .replace(/\brechargeable\b/g, ' ')
      .replace(/\blamp\b/g, ' ')
      .replace(/\bholder\b/g, ' holder ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    // aladdins ↔ aladdin; do not use substring contains (table ⊂ mini table).
    return t
      .split(' ')
      .filter(Boolean)
      .map(function (tok) {
        if (tok.length > 3 && tok.charAt(tok.length - 1) === 's') return tok.slice(0, -1);
        return tok;
      })
      .join(' ');
  }

  /** True when `hay` starts with `needle` as a full token prefix (not mid-word). */
  function startsWithDesignToken(hay, needle) {
    if (!hay || !needle) return false;
    if (hay === needle) return true;
    if (hay.indexOf(needle) !== 0) return false;
    var next = hay.charAt(needle.length);
    return !next || next === ' ' || next === '/' || next === '-' || next === '|';
  }

  function designMatches(v, designLabel) {
    var label = normKey(designLabel);
    if (!label) return false;
    var o1 = normKey(v.option1 || '');
    var title = normKey(v.title || '');
    if (o1 && o1 === label) return true;
    if (title && title === label) return true;
    // Design-only title, or "Candle Holder / January 16 / 2 pm"
    if (title && startsWithDesignToken(title, label)) return true;
    if (o1 && startsWithDesignToken(label, o1)) return true;
    var aLabel = designAliasKey(label);
    var aO1 = designAliasKey(o1);
    // Exact alias only — substring matched "table" inside "mini table" and
    // carted Mini Table Lamp when the customer picked Table Lamp.
    if (aLabel && aO1 && aLabel === aO1) return true;
    return false;
  }

  function blobHasAny(blob, hints) {
    if (!blob || !hints || !hints.length) return false;
    for (var i = 0; i < hints.length; i++) {
      if (hints[i] && blob.indexOf(hints[i]) >= 0) return true;
    }
    return false;
  }

  function allowedSellIdsFromSlot(slot) {
    var raw = (slot && slot._raw) || slot || {};
    var out = [];
    var seen = Object.create(null);
    function add(id) {
      var s = String(id || '').trim();
      if (!s) return;
      var m = s.match(/ProductVariant\/(\d+)/i);
      if (m) s = m[1];
      if (!/^\d+$/.test(s)) return;
      if (seen[s]) return;
      seen[s] = true;
      out.push(s);
    }
    var av = raw.available_variants;
    if (Array.isArray(av)) {
      av.forEach(function (it) {
        if (it == null) return;
        if (typeof it === 'string' || typeof it === 'number') add(it);
        else add(it.id || it.variant_id || it.variantId);
      });
    }
    if (raw.variant_id != null) add(raw.variant_id);
    if (slot && slot.variant_id != null) add(slot.variant_id);
    return out;
  }

  function dateSessionHintsFromSlot(slot) {
    var dates = dateHintsFromSlot(slot);
    var times = timeHintsFromSlot(slot);
    var out = dates.concat(times);
    // Canada option2 is often "January 16 / 2 pm" (date + session in one value).
    dates.forEach(function (d) {
      times.forEach(function (t) {
        out.push(d + ' / ' + t);
        out.push(d + '/' + t);
        out.push(d + ' ' + t);
      });
    });
    return out.map(normKey).filter(Boolean);
  }

  function pickBestSellVariant(candidates) {
    if (!candidates || !candidates.length) return null;
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] && candidates[i].available !== false) return candidates[i];
    }
    // Prefer returning an unavailable match over a random other design — caller
    // can surface Shopify sold-out for the *correct* title. Still better than
    // falling through to the hub SKU.
    return candidates[0];
  }

  /**
   * Map hub design variant → city product sell variant.
   * Canada city products often use Lamp Type + Date/Session options; matching
   * option1 alone used to cart a random (often sold-out) date row.
   * Never returns the hub variant id — empty string means "no city match".
   */
  function remapHubVariantId(venue, hubVariantId, hubVariantLabel, slot) {
    if (!venue) return '';
    var label = normKey(hubVariantLabel);
    var variants = venue._sellVariants || [];
    if (!variants.length) {
      if (label && venue._sellVariantByLabel && venue._sellVariantByLabel[label]) {
        return venue._sellVariantByLabel[label];
      }
      return '';
    }

    var allowed = allowedSellIdsFromSlot(slot);
    var sessionHints = dateSessionHintsFromSlot(slot);

    var pool = variants.slice();
    if (allowed.length) {
      var allowSet = Object.create(null);
      allowed.forEach(function (id) {
        allowSet[id] = true;
      });
      var filtered = pool.filter(function (v) {
        return allowSet[String(v.id)];
      });
      // Only shrink when the allow-list intersects (some events stamp all variants).
      if (filtered.length && filtered.length < pool.length) pool = filtered;
    }

    if (!label) return '';

    var byDesign = pool.filter(function (v) {
      return designMatches(v, label);
    });
    // Do NOT fall back to the full pool — that carted Mini Table when Aladdin
    // failed a strict label match.
    if (!byDesign.length) return '';

    var sessioned = byDesign;
    if (sessionHints.length) {
      var sMatch = byDesign.filter(function (v) {
        return blobHasAny(variantTextBlob(v), sessionHints);
      });
      if (sMatch.length) sessioned = sMatch;
    }

    var pick = pickBestSellVariant(sessioned);
    return pick ? String(pick.id) : '';
  }

  global.WorkshopBookingCoralHub = {
    isCoralHub: isCoralHub,
    typeCollectionHandle: typeCollectionHandle,
    boot: boot,
    loadMore: loadMore,
    fetchVenueCalendar: fetchVenueCalendar,
    windowBounds: windowBounds,
    prefetchSellVariants: prefetchSellVariants,
    remapHubVariantId: remapHubVariantId,
    warmSearchCatalog: warmSearchCatalog,
    selectVenueFromSearch: selectVenueFromSearch,
    INITIAL_TARGET: INITIAL_TARGET,
    PAGE_SIZE: PAGE_SIZE,
  };
})(typeof window !== 'undefined' ? window : this);
